import { createSlice } from "@reduxjs/toolkit";

// Caches the signed-in administrator's Arbiter Auth permission strings
// (e.g. "auth:role:read") and global role names (e.g. "OperationsAdmin"),
// derived from GET /assigned/user/roles + GET /roles, so components can gate UI
// without re-fetching or re-deriving on every render.
const initialState = {
  permissions: null, // null = not yet loaded; [] = loaded, no permissions
  roleNames: null, // null = not yet loaded; [] = loaded, no roles
  loaded: false,
};

export const accessPermissionsSlice = createSlice({
  name: "accessPermissions",
  initialState,
  reducers: {
    setAccessPermissions: (state, action) => {
      state.permissions = action.payload || [];
      state.loaded = true;
    },
    setAccessRoleNames: (state, action) => {
      state.roleNames = action.payload || [];
    },
    clearAccessPermissions: (state) => {
      state.permissions = null;
      state.roleNames = null;
      state.loaded = false;
    },
  },
});

export const { setAccessPermissions, setAccessRoleNames, clearAccessPermissions } =
  accessPermissionsSlice.actions;
